import { ReactComponent as TreasuryIcon } from "../../assets/dollarCircle.svg";
import { ReactComponent as VaultIcon } from "../../assets/vaultIcon.svg";
import { ReactComponent as InvitationsIcon } from "../../assets/invitations.svg";
import { ReactComponent as ProposalsIcon } from "../../assets/layer.svg";
import { ReactComponent as SummaryIcon } from "../../assets/summaryWhite.svg";
import { ReactComponent as MembersIcon } from "../../assets/user.svg";
import { ReactComponent as ApplicationsIcon } from "../../assets/userAdd.svg";
import { ReactComponent as StakingIcon } from "../../assets/summaryStakingIcon.svg";

import {
  ClubSortType,
  ClubType,
  FilterType,
  SummaryTabIdentifiers,
  SummaryTabNames,
} from "../enums/club.enum";
import { ApplicationStatus } from "../enums/clubs-wizard.enum";
import {
  IClubBasicInfo,
  ISortItem,
  ISummaryTab,
} from "../interfaces/clubs.interface";
import { PublicKey } from "@solana/web3.js";
import { mint } from "../../solana/common/utilities";
import { EMPTY_STRING } from "./common.constants";

export const summaryTabsConfig: ISummaryTab[] = [
  {
    icon: SummaryIcon,
    title: SummaryTabNames.summary,
    id: SummaryTabIdentifiers.summary,
  },
  {
    icon: MembersIcon,
    title: SummaryTabNames.members,
    id: SummaryTabIdentifiers.members,
  },
  {
    icon: TreasuryIcon,
    title: SummaryTabNames.treasury,
    id: SummaryTabIdentifiers.treasury,
  },
  {
    icon: VaultIcon,
    title: SummaryTabNames.vault,
    id: SummaryTabIdentifiers.vault,
  },
  {
    icon: ProposalsIcon,
    title: SummaryTabNames.proposals,
    id: SummaryTabIdentifiers.proposals,
  },
  {
    icon: ApplicationsIcon,
    title: SummaryTabNames.applications,
    id: SummaryTabIdentifiers.applications,
  },
  {
    icon: InvitationsIcon,
    title: SummaryTabNames.invitations,
    id: SummaryTabIdentifiers.invitations,
  },
  {
    icon: StakingIcon,
    title: SummaryTabNames.staking,
    id: SummaryTabIdentifiers.staking,
  },
];

export const sortClubItems: ISortItem[] = [
  {
    title: "Newest first",
    type: ClubSortType.NewestFirst,
  },
  {
    title: "Oldest first",
    type: ClubSortType.OldestFirst,
  },
  {
    title: "Highest funds raised first",
    type: ClubSortType.HighestFundsRaisedFirst,
  },
  {
    title: "Highest number of members first",
    type: ClubSortType.HighestNumberOfMembersFirst,
  },
  // TODO@milica: add this sort type after indexing
  // {
  //   title: "Highest number of NFTs first",
  //   type: ClubSortType.HighestNumberOfNFTsFirst,
  // },
];

export const PROPOSAL_START_DATE = "proposalStartDate";
export const PROPOSAL_END_DATE = "proposalEndDate";
export const MAX_SELL_PERMISSIONS_FOR_TREASURY_GOVERNANCE_IX = 3;
export const MAX_SELL_PERMISSIONS_FOR_CLUB = 10;
export const MAX_MEMBERS_FOR_CLUB = 99;
export const MAX_SOL_AMOUNT_PER_FUNDRAISE = 100000;

//TODO@milica-monke-merge: For monke 10,000,000, for main 20000000
export const MAX_USDC_AMOUNT_PER_FUNDRAISE = 10000000;

//TODO@milica-monke-merge: For monke 1, for main 0.1
export const MIN_AMOUNT_PER_FUNDRAISE = 1;

export const LEFT_POSITION_TOOLTIP_PERCENTAGE = 19;
export const LEFT_POSITION_TOOLTIP_PERCENTAGE_MOBILE = 50;
export const PROPOSAL_DESCRIPTION_MAX_LENGTH = 500;

export const clubType = [
  {
    label: "Role-based",
    value: ClubType.RoleBased,
    filterType: FilterType.ClubType,
  },
  {
    label: "Deposit-based",
    value: ClubType.TokenProportional,
    filterType: FilterType.ClubType,
  },
  {
    label: "Nft-based",
    value: ClubType.NftBased,
    filterType: FilterType.ClubType,
  },
];

export const applicationStatus = [
  {
    label: "Open",
    value: ApplicationStatus.Opened,
    filterType: FilterType.ApplicationStatus,
  },
  {
    label: "Close",
    value: ApplicationStatus.Closed,
    filterType: FilterType.ApplicationStatus,
  },
];

export const activeFundraising = [
  {
    label: "Yes",
    value: true,
    filterType: FilterType.ActiveFundraising,
  },
  {
    label: "No",
    value: false,
    filterType: FilterType.ActiveFundraising,
  },
];

export const clubBasicInfoIntialState: IClubBasicInfo = {
  address: EMPTY_STRING,
  name: EMPTY_STRING,
  type: ClubType.TokenProportional,
  description: EMPTY_STRING,
  owner: EMPTY_STRING,
  imageUrl: EMPTY_STRING,
  email: EMPTY_STRING,
  applicationStatus: ApplicationStatus.Closed,
  twitter: EMPTY_STRING,
  discord: EMPTY_STRING,
  telegram: EMPTY_STRING,
  linkedin: EMPTY_STRING,
  reddit: EMPTY_STRING,
  instagram: EMPTY_STRING,
  tiktok: EMPTY_STRING,
  tags: [],
  roleConfig: [],
  numberOfMembers: 0,
  communityMint: new PublicKey(mint),
  governances: [],
  kycConfig: undefined,
};
